import { ToastrService } from 'ngx-toastr';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { StatusCodes } from 'http-status-codes';

@Injectable()
export class BaseService {
  private apiUrl = environment.apiEndpoint;

  constructor() { }

  public getUrl(modelo: string) {
    return `${this.apiUrl}${modelo}`;
  }

  public handleError(error: Response | any, toastr: ToastrService) {
    switch (error.status) {
      case StatusCodes.UNAUTHORIZED:
        toastr.warning('Problemas de permisos, inténtelo de nuevo o póngase en contacto con el administrador.', 'Advertencia');
        break;
      case StatusCodes.NOT_FOUND:
      case StatusCodes.BAD_REQUEST:
        toastr.warning(error.error, 'Advertencia');
        break;
      default:
        throw error;
    }
  }
}
